import styled from 'styled-components';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';

export const Wrapper = styled.div`
  padding: 16px;
  height: 600px;
`;

export const InfoBoxWrapper = styled.div`
  padding: 16px;
  height: 600px;
  width: 500px;
`;

export const SaveButton = styled(Button)`
  width: 200px;
`;
